import { Component, OnInit } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';

/**
 * Modules
 */
import { AlertModule } from 'ng2-bootstrap';

//import {DataTableModule} from "angular2-datatable";

@Component({
  selector: 'cef-memberList',
  templateUrl: './importMember.component.html'
})

export class ImportMemberComponent implements OnInit {
	public currUser;
	public csv = '';
	public problemArr = new Array();
	public currTeacherArr = new Array();
	public allowableLevel = {'網站管理員':0,'行政管理員':1,'栽培管理員':2,'導師':3,'正式會員':4,'普通會員':5};
	public keyName = ['email', 'password', 'name', 'gender', 'level', 'unit', 'group', 'dateOfBirth'];
	public showWarning = false;
	public processing = false;
	public processingMsg = '處理中，請稍候！';
	public numOfProcess = 0;

    editProfile = {
    	name:'',
    	dateOfBirth:'',
    	gender:'',
    	level:'',
    	unit:'',
		group:'',
    	tutor:'',
    	created: '',
		createdBy: '',
		modified: '',
		modifiedBy: ''
    } 

	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngOnInit(): void {
		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) this.currUser = user;
		});

		let db = firebase.database();
		db.ref('profile/').once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					let returnVal = snapshot.val();
					if (returnVal[this.currUser.uid].level > 2){
						//not allow to enter
						//if (returnVal[this.currUser.uid].level== 2 || returnVal[this.currUser.uid].level == 3) {
						if (returnVal[this.currUser.uid].level> 2) {
                            this.router.navigate(['/webadmin/message']);
                        } else {
                            this.router.navigate(['/member/dashboard']);
                        }
					}
					for(let uid of Object.keys(returnVal)){
						if (returnVal[uid].level == 'teacher') {
							this.currTeacherArr[returnVal[uid].name] = uid;
						}
					}
				}
			}
		)

    }

    importMember() {
    	this.processing = true;
    	this.showWarning = false;
    	this.problemArr = [];
    	var importedMemberList = this.CSVToArray();
	    var validMember = [];
	    this.processingMsg = '處理中，請稍候！';
	    this.numOfProcess = 0;
	    
	    var validDateFormat = /^\d{4}-\d{2}-\d{2}$/;
	    var validPassword = /^[A-Za-z]\w{5,}$/;
	    for (var i = 0; i < importedMemberList.length; i++) {
	        validMember[i] = {};
	        this.problemArr[i] = '';
	        for (var k = 0; k < importedMemberList[0].length && k < importedMemberList[i].length; k++) {
	        	if (importedMemberList[i][k]){
	        		var key = this.keyName[k];
		            if (key == 'email'){
		            	this.http.get(this.memberService.EBURL+"getMemberInfoByEmail/"+importedMemberList[i][k]+"/"+i).subscribe((res:any)=> {
							res = res.json();
							if (!res.code) this.problemArr[res] += '電郵已有註冊！';
			            });
		            }
		            if (key == 'gender'){
		            	if (importedMemberList[i][k] != '男' && importedMemberList[i][k] != '女') this.problemArr[i] += "性別只接受'男'或'女'！";
		            }
		            if (key == 'level'){
		            	if (!this.allowableLevel[importedMemberList[i][k]]) this.problemArr[i] += "找不到預設身份！";
		            	importedMemberList[i][k] = this.allowableLevel[importedMemberList[i][k]];
		            }
					
		            if (key == 'dateOfBirth'){
		            	if (!importedMemberList[i][k].match(validDateFormat)){
		            		this.problemArr[i] += "日期格式必須是 'YYYY-MM-DD'！";
		            	}
		            }
		            if (key == 'password'){
						if (!importedMemberList[i][k].match(validPassword)){
		            		this.problemArr[i] += "密碼必需由6個或以上的字母或數字組成！";
		            	}
		            }
	        	}
	        	validMember[i][key] = importedMemberList[i][k];
	        }
	    }

	    setTimeout(()=>{
	    	var haveError = false;
	    	this.processingMsg = '處理中，請稍候！';

	    	for (let index in this.problemArr){
	    		if (this.problemArr[index] != '') {
	    			haveError = true;
	    			break;
	    		}
	    	}

	    	if (!haveError) {
	    		//start save
	    		for (let entry of validMember){
	    			this.http.get(this.memberService.EBURL+"addMember/"+entry.email+"/"+entry.password).subscribe((res:any)=> {
						res = res.json();
						if (res.code){
							//collect error message res.message
						} else if (res.uid) {
							let db = firebase.database();
							entry.name = entry.name?entry.name:'';
					    	entry.unit = entry.unit?entry.unit:'';
							entry.group = entry.group?entry.group:'';
					    	entry.name = entry.name.trim();
					    	entry.unit = entry.unit.trim();
							entry.group = entry.group.trim();
					    	delete entry.email;
					    	delete entry.password;
							db.ref('profile/' + res.uid).set({
					    		name: entry.name,
						    	dateOfBirth: entry.dateOfBirth?entry.dateOfBirth:'',
						    	gender: entry.gender?entry.gender:'',
						    	level: entry.level?entry.level:'',
						    	unit: entry.unit,
								group: entry.group,
						    	tutor: '',
						    	created: (new Date()).toString(),
			    				createdBy: this.currUser.uid,
			    				modified: (new Date()).toString(),
			    				modifiedBy: this.currUser.uid
							}).then(
								()=>{
									this.numOfProcess++;
									if (this.numOfProcess == validMember.length){
										this.processingMsg = '處理完成，資料已匯入，可進行配對。';
									} else {
										this.processingMsg = '處理' + this.numOfProcess + '/' + validMember.length + '中，請稍候！';
										this.processing = true;
									}
								}
							).catch(
								(error:any) => {
									console.log(error);
									//collect error message res.message
								}
							);
						}
		            });
	    		}
	    		//this.processing = true;
	    		//this.processingMsg = '處理完成，資料已匯入，可進行配對。';
	    	} else {
	    		this.processing = false;
	    		this.showWarning = true;
	    	}
	    },2000);
    }

    CSVToArray() {
    	// Check to see if the delimiter is defined. If not,
	    // then default to comma.
	    let strDelimiter = ",";
	    // Create a regular expression to parse the CSV values.
	    var objPattern = new RegExp((
	    // Delimiters.
	    "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
	    // Quoted fields.
	    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
	    // Standard fields.
	    "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
	    // Create an array to hold our data. Give the array
	    // a default empty first row.
	    let arrData = [[]];
	    // Create an array to hold our individual pattern
	    // matching groups.
	    let arrMatches = null;
	    // Keep looping over the regular expression matches
	    // until we can no longer find a match.
	    
	    while (arrMatches = objPattern.exec(this.csv)) {
	        // Get the delimiter that was found.
	        var  strMatchedDelimiter = arrMatches[1];
	        // Check to see if the given delimiter has a length
	        // (is not the start of string) and if it matches
	        // field delimiter. If id does not, then we know
	        // that this delimiter is a row delimiter.
	        if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
	            // Since we have reached a new row of data,
	            // add an empty row to our data array.
	            arrData.push([]);
	        }
	        // Now that we have our delimiter out of the way,
	        // let's check to see which kind of value we
	        // captured (quoted or unquoted).
	        if (arrMatches[2]) {
	            // We found a quoted value. When we capture
	            // this value, unescape any double quotes.
	            var strMatchedValue = arrMatches[2].replace(
	            new RegExp("\"\"", "g"), "\"");
	        } else {
	            // We found a non-quoted value.
	            var strMatchedValue = arrMatches[3];
	        }
	        // Now that we have our value string, let's add
	        // it to the data array.
	        if (strMatchedValue) strMatchedValue = strMatchedValue.toString().trim();
	        arrData[arrData.length - 1].push(strMatchedValue);
	    }
	    // Return the parsed data.
	    return (arrData);
    }

 
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/importMember.component.ts